module.exports = __webpack_public_path__ + "54cf98f5/img/share-icon.0f8a11b4.svg";